module.exports = __webpack_public_path__ + "static/media/mom2.f9384ce7.jpg";